/**
 * 字典文案国际化
 * - 根据接口返回的 typeId、id，从当前语言的 JSON 中取展示文案
 * - 支持 zh-CN、en-US，后续可扩展其他语言
 */
import zhCN from './dictionaries/zh-CN.json';
import enUS from './dictionaries/en-US.json';

const dictionaries = {
  'zh-CN': zhCN,
  'en-US': enUS,
};

const FALLBACK_LOCALE = 'zh-CN';

/**
 * 根据字典类型、项 id 和语言，返回对应文案
 * @param {string|number} typeId - 字典大类 ID（如 6158、6003）
 * @param {string|number} id - 字典项 ID（如 6158001）
 * @param {string} [locale] - 语言，如 'zh-CN' | 'en-US'；不传则用 fallback
 * @returns {string} 文案，找不到时返回空字符串或 id 的字符串形式
 */
export function getDictionaryName(typeId, id, locale = FALLBACK_LOCALE) {
  const t = String(typeId);
  const i = String(id);
  const dict = dictionaries[locale] || dictionaries[FALLBACK_LOCALE];
  const byType = dict && dict[t];
  const name = byType && byType[i];
  return name != null ? name : '';
}

/**
 * 将接口返回的字典列表转为带当前语言 name 的选项（保留 id，name 用字典文案）
 * @param {string|number} typeId - 字典大类 ID
 * @param {Array<{id: string|number, name?: string}>} list - getDictionaryList 返回的 data
 * @param {string} locale - 当前语言
 * @returns {Array<{id, name, key?, value?}>} 项含 id、name（已国际化），以及 key/value 便于下拉使用
 */
export function mapDictionaryListToOptions(typeId, list, locale = FALLBACK_LOCALE) {
  if (!Array.isArray(list)) return [];
  return list.map((item) => {
    const name = getDictionaryName(typeId, item.id, locale);
    return {
      ...item,
      name: name || item.name || String(item.id),
      key: item.id,
      value: name || item.name || String(item.id),
    };
  });
}

export default getDictionaryName;
